import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_CREATE_COLLECTION_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
export function createCollection(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_SUCCESS,
              data: res.data,
            });
            Mixpanel.track('Created Collection', {
              uuid: res.data.uuid,
              colletionName: res.data.colletionName,
            });
            toast.success('Collection Created Successfully !');
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to creat collection');
            toast.error(`Failed: ${errMsg}`, {});
            resolve('Failed');
          }
        },
        (err) => {
          console.log('err.response :>> ', err.response);
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          if (err.response.status && err.response.status === 400) {
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_FAILURE,
              data: { error: errMsg },
            });
            resolve(errMsg);
          }
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_BEGIN:
      return {
        ...state,
        createCollectionPending: true,
        createCollectionError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_SUCCESS:
      return {
        ...state,
        createCollectionPending: false,
        createCollectionError: null,
        projectCollections: [...state.projectCollections, action.data],
        selectedCollection: action.data,
        items: [],
      };

    case COLLECTIONS_CREATE_COLLECTION_FAILURE:
      return {
        ...state,
        createCollectionPending: false,
        createCollectionError: action.data.error,
      };

    case COLLECTIONS_CREATE_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createCollectionError: null,
      };

    default:
      return state;
  }
}
